export const DEFAULT_ADMIN_API_BASE_URL = 'https://www.noranest.cn';

export const ADMIN_API_BASE_URL =
  process.env.ADMIN_API_BASE_URL || DEFAULT_ADMIN_API_BASE_URL;
